<div class="related-data-container">
  <div class="related-data-label-container">
    <p>{{translationsService.translate(controlTitle)}}</p>
  </div>

  @if (resultItems && resultItems.length > 0 && inlineLayout == false) {
    <div class="related-data-table-container">
      <table class="related-data-table" cellspacing="0" cellpadding="0">
        <thead>
          @if (!columnsJson) {
            <tr>
              <th>{{translationsService.translate("Translation.Title")}}</th>
              <th>{{translationsService.translate("")}}</th>
            </tr>
          }
          @if (columnsJson) {
            <tr>
              @for (column of columnsJson; track column) {
                <th>{{translationsService.translate(column.Translation)}}</th>
              }
              <th>{{translationsService.translate("")}}</th>
            </tr>
          }
        </thead>
        <tbody>
          @if (!columnsJson) {
            @for (item of resultItems; track item) {
              <tr>
                <td>
                  <p class="q-item-p">{{item.Title}}</p>
                </td>
                @for (item of resultItems; track item) {
<td><a [href]="item.DetailsFormUrl+'?id='+item.Id" target="_blank"><img class="item-link-img"
                                    src="../../../../assets/css/images/platform/s-icon-open@3x.png" /></a></td>
}
                    </tr>
}
                
}
                @if (columnsJson) {

                    @for (item of resultItems; track item) {
<tr>
                        @for (column of columnsJson; track column) {
                        <td>
                            @if (!isValidDate(column.PropertyPath)) {
<p class="q-item-p">{{dfms.getValue(item,
                                column.PropertyPath)}}</p>
}
                            @if (isValidDate(column.PropertyPath)) {
<p class="q-item-p">{{dfms.getValue(item,
                                column.PropertyPath) | date: 'dd.MM.yyyy'}}</p>
                    }
                  </td>
                }
                @if (item.DetailsFormUrl) {
<td><a [href]="item.DetailsFormUrl+'?id='+item.Id" target="_blank"><img class="item-link-img"
                                    src="../../../../assets/css/images/platform/s-icon-open@3x.png" /></a></td>
}
                    </tr>
}
                
}
            </tbody>
        </table>

        @if (resultItems.length > 0) {
<div class="related-data-pagination">
            @if (previousPage != 0) {
<img src="../../../../assets/css/images/platform/icon-arrow-left@3x.png" class="page-left"
                (click)="pageChanged(previousPage)">
}
            @for (page of pages; track page) {
<p [ngClass]="{'active': page.Active == true}"
                (click)="pageChanged(page.Number)">{{page.Number}}</p>
}
            @if (nextPage != 0) {
<img src="../../../../assets/css/images/platform/icon-arrow-right.png" class="page-right"
                (click)="pageChanged(nextPage)">
}
        </div>
}

    </div>
}

    <ng-scrollbar [visibility]="'hover'" [track]="'all'" [autoHeightDisabled]="false">
        @if (inlineLayout) {
<div class="inline-layout-query">

            @if (!columnsJson) {

                @for (item of resultItems; track item) {
<a [href]="item.DetailsFormUrl+'?id='+item.Id"
                        target="_blank">{{item.Title}}</a>
                
}
            
}
            @if (columnsJson) {

                @for (item of resultItems; track item; let idx = $index) {

                    @for (column of columnsJson; track column;) {

                    @if (showInlineWithoutUrl == false && redirectUrl && redirectUrl.length > 0) {
<a [href]="dfms.getValue(item, redirectUrl)"
                        target="_blank">{{dfms.getValue(item, column.PropertyPath)}}</a>
}

                    @if (showInlineWithoutUrl == false && !isValidDate(column.PropertyPath) && item.DetailsFormUrl && item.DetailsFormUrl.length > 0 && redirectUrl.length == 0 && (dfms.getValue(item, column.PropertyPath) && dfms.getValue(item, column.PropertyPath).length > 0)) {
<a [href]="item.DetailsFormUrl+'?id='+item.Id"
                        target="_blank">{{dfms.getValue(item, column.PropertyPath)}}</a>
}

                    @if (showInlineWithoutUrl == false && isValidDate(column.PropertyPath) && item.DetailsFormUrl && item.DetailsFormUrl.length > 0 && redirectUrl.length == 0 && (dfms.getValue(item, column.PropertyPath) && dfms.getValue(item, column.PropertyPath).length > 0)) {
<a [href]="item.DetailsFormUrl+'?id='+item.Id"
                        target="_blank">{{dfms.getValue(item,
                        column.PropertyPath) | date: 'dd.MM.yyyy'}}</a>
              }
              @if (isValidDate(column.PropertyPath) && showInlineWithoutUrl) {
                <span class="sem-query-inline-item-data">{{dfms.getValue(item,column.PropertyPath) | date: 'dd.MM.yyyy'}}</span>
              }
              @if (!isValidDate(column.PropertyPath) && showInlineWithoutUrl) {
                <span class="sem-query-inline-item-data" >{{dfms.getValue(item,column.PropertyPath)}}</span>
              }
            }
            @if (resultItems.length-1 != idx && (dfms.getValue(item, columnsJson[0].PropertyPath) && dfms.getValue(item, columnsJson[0].PropertyPath).length > 0)) {
              <span>, </span>
            }
          }
        }
      </div>
    }
  </ng-scrollbar>

  @if ((!resultItems || resultItems.length == 0) && noRecordsText) {
    <div class="query-no-records">
      <p>{{noRecordsText}}</p>
    </div>
  }
</div>